<!--自动识别设置-->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
        <span v-for="(warn, idx) in form.printWarns" :key="idx">
            <el-row>
                <el-col :xs="24" :sm="24" :md="16" style="padding: 10px 5px">
                    <el-form-item label-width="180px" :label="msg('打印时货物未到齐提醒：')">
                        <el-radio v-model="warn.printWarn" label="0">提醒</el-radio>
                        <el-radio v-model="warn.printWarn" label="1">不提醒</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="16" style="padding: 10px 5px">
                    <el-form-item label-width="180px" :label="msg('货单二维码设置：')">
                        <!-- <el-radio v-model="warn.printType" label="0">条形码</el-radio>
                        <el-radio v-model="warn.printType" label="1">二维码</el-radio> -->
                        <el-checkbox v-model="warn.printType">二维码</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :xs="24" :sm="24" :md="16" style="padding: 10px 5px">
                    <span
                        style="font-size:14px; color:#666666; margin-right:10px;">{{ msg('架位识别规则') }}</span>
                    <el-tag v-for="(tag, idx) in pkgRules" :key="idx"
                            :type="tag.type == 0 ? 'danger':''"
                            closable @close="buildPkgRule(idx)"
                            style="margin: 5px;"
                    >
                        {{ tag.name }}({{ tag.len }})
                    </el-tag>
                </el-col>
                <el-col :xs="24" style="padding: 15px">
                    <el-select v-model="selectedRuleType" placeholder="请选择" size="mini">
                        <el-option label="数字" value="数字"></el-option>
                        <el-option label="字母" value="字母"></el-option>
                        <el-option label="横杠" value="横杠"></el-option>
                    </el-select>
                    <el-input-number v-model="selectedRuleLength" :min="1" :max="10" size="mini"
                                     label="长度">
                    </el-input-number>
                    <el-button type="primary" @click="addPkgRule" plain size="mini">添加</el-button>
                </el-col>
            </el-row>
        </span>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingRecognition",
  data() {
    return {
      xgroup: 'PRINT_WARN',
      pkgRules: [],
      selectedRuleType: null,
      selectedRuleLength: null,
      pkgRuleRegExp: null,
      pkgRuleLength: null,
      form: {
        printWarns:[],
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.printWarns = [];
      let printWarns = data;//打印提醒
      //打印提醒
      if (printWarns.length > 0) {
        printWarns.forEach(a => {
          if (a.xvalue) {
            let ws = JSON.parse(a.xvalue);
            let printWarn = ws.printWarn ? ws.printWarn : 0;
            let pkgRules = ws.pkgRules ? ws.pkgRules : [];
            let printType = ws.printType ? true : false;
            let warn = {
              id: a.id ? a.id : null,
              xkey: 'PRINT_WARN',
              owner: a.owner ? a.owner : null,
              xgroup: 'PRINT_WARN',
              // xvalue: a.xvalue,
              printWarn: printWarn,
              printType: printType,
              pkgRules: pkgRules,
              xtype: 1
            }
            _this.form.printWarns.push(warn);
            this.pkgRules = pkgRules;
          }
        })
      } else {
        _this.form.printWarns.push({
          id: null,
          xkey: 'PRINT_WARN',
          owner: null,
          xgroup: 'PRINT_WARN',
          // xvalue: 0,
          printWarn: 0,
          printType: false,
          pkgRules: [],
          xtype: 0
        })
      }
    },
    addPkgRule(){//添加袋号自动录入规则
      if(this.selectedRuleType && this.selectedRuleLength){

        this.pkgRules.push({
          type: this.selectedRuleType == '数字'?0:this.selectedRuleType == '字母'?1:2,
          name: this.selectedRuleType,
          len: this.selectedRuleLength,
        });

        this.buildPkgRule(-1);
        this.selectedRuleType = null;
        this.selectedRuleLength = null;

      }
    },
    buildPkgRule(index){
      if(index>-1){
        this.pkgRules.splice(index, 1);
      }
      if(this.pkgRules.length==0){
        this.pkgRuleRegExp = null;
        return;
      }

      let regStr = "";
      let len = 0;
      this.pkgRules.forEach(r => {
        regStr += (r.type == 0?"[0-9]":"[a-zA-Z]");
        regStr += "{"+r.len+"}";
        len += r.len;
      });

      this.pkgRuleRegExp = new RegExp(regStr);
      this.pkgRuleLength = len;

    },
    update() {
      let datas = [];
      //构建打印提醒设置
      for (let i = 0; i < this.form.printWarns.length; i++) {
        let warn = this.form.printWarns[i];
        let key = this.xgroup;
        datas.push({
          id: warn.id,
          xkey: key,
          owner: warn.owner ? warn.owner : null,
          xgroup: this.xgroup,
          // xvalue: warn.xvalue,
          xvalue: JSON.stringify({
            printWarn: warn.printWarn ? warn.printWarn : 0,
            printType: warn.printType ? warn.printType : false,
            pkgRules: this.pkgRules,
          }),
          xtype: 1
        });
      }
      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>